import React from 'react';
import { createRoot, Root } from 'react-dom/client';

const roots = new WeakMap<Element, Root>();

export function mountReactNode(container: Element, node: React.ReactNode): Root {
    let root = roots.get(container);

    if (!root) {
        root = createRoot(container);
        roots.set(container, root);
    }

    root.render(node);

    return root;
}
